import { Anchor } from 'antd'
import { createStyles } from 'antd-style'

import { useConsoleLayout } from '../../../../../layouts/ConsoleLayout/hooks'

const useStyles = createStyles(({ prefixCls, token }) => ({
  container: {
    padding: 0,
    marginBlockStart: 0,
    marginBlockEnd: token.marginXL,
    background: token.colorBgContainer,
    [`& .${prefixCls}-anchor`]: {
      width: 896,
      margin: '0 auto',
      [`&  .${prefixCls}-anchor-link`]: {
        padding: `${token.paddingMD}px !important`
      }
    }
  }
}))

const items = [
  {
    key: 'kindPanel',
    href: '#kindPanel',
    title: '交易意向品类'
  },
  {
    key: 'businessLicensePanel',
    href: '#businessLicensePanel',
    title: '企业营业执照'
  },
  {
    key: 'otherInfoPanel',
    href: '#otherInfoPanel',
    title: '企业其他信息'
  }
]

export const AuditEnterpriseFormAnchor = () => {
  const { ref } = useConsoleLayout()

  const { styles } = useStyles()
  return (
    <Anchor
      affix
      bounds={150}
      direction='horizontal'
      getContainer={() => ref.current ?? window}
      items={items}
      rootClassName={styles.container}
    />
  )
}
